<template>
  <div id="app">
    <router-view v-if="isRouter"/>
  </div>
</template>

<script>
import {httpAnon, httpUser, api_type} from "./assets/js/api";
import util from './assets/js/util';
import './assets/css/reset.css'
import './assets/css/style.stylus'
export default {
  name: 'App',
  provide(){
    return{
			reload:this.reload
		}
	},
	data(){
		return{
			isRouter:true
		}
	},
	methods:{
		reload(){
			this.isRouter = false
			this.$nextTick(function () {
				this.isRouter = true
			})
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>




// WEBPACK FOOTER //
// src/App.vue